export default __webpack_public_path__ + "static/media/Settings.13287c2f.svg";